import { callApi } from 'utils/api/callApi'
import { FP_ENDPOINTS } from 'apps/fleet-planner/config'
import { IShipmentMotorCarrier } from 'apps/fleet-planner/schema'
import { ICarrier } from 'apps/fleet-planner/types'
import * as Types from 'apps/fleet-planner/types'

export const fetchAllCarriers = (): Promise<Types.IGetAllCarriersResponse> => {
  return callApi({
    endpoint: FP_ENDPOINTS.motorCarriers,
    method: 'GET',
  })
}

export const fetchAllUserMotorCarriers = (): Promise<Types.IGetUserMotorCarriers> => {
  return callApi({
    endpoint: FP_ENDPOINTS.userMotorCarriers,
    method: 'GET',
  })
}

export const submitRemoveMotorCarriers = (id: number): Promise<Types.IGetMotorCarriersResponse> => {
  return callApi({
    endpoint: FP_ENDPOINTS.userMotorCarriersRemove,
    method: 'DELETE',
    id,
  })
}

/**
 * Converts similar types
 */
export const formatCarrier = (mc: IShipmentMotorCarrier | undefined): ICarrier | undefined => {
  if (!mc) return undefined
  const { id, name } = mc || {}
  return {
    id,
    name,
  }
}
